import styled from '@emotion/styled'

export const Clickable = styled.div`
  cursor: pointer;
`
